import type { ChatPlayerRole, ChatPlayerTranscriptSource } from "@ui/components/core/ChatPlayer";

export type AudioDemoPreviewSpeakerRole = {
  role: ChatPlayerRole;
  speakerId: string;
};

function getConfiguredSpeakerRoles(speakerRoles: AudioDemoPreviewSpeakerRole[] | null | undefined) {
  return Object.fromEntries(speakerRoles?.map(({ role, speakerId }) => [speakerId, role]) ?? []);
}

export function createChatPlayerSourceFromChatTranscript(
  transcript: ChatPlayerTranscriptSource | null | undefined,
  configuredSpeakerRoles?: AudioDemoPreviewSpeakerRole[] | null,
) {
  if (!transcript?.segments.length) {
    return null;
  }

  return {
    language_code: transcript.language_code,
    segments: transcript.segments,
    speakerRoles: getConfiguredSpeakerRoles(configuredSpeakerRoles),
  } satisfies ChatPlayerTranscriptSource;
}
